export function headerNav() {
    const $body = $("body");
    const $window = $(window);
    const $header = $(".header");
    let $menuOpener = $(".mobile-menu-opener");
    $menuOpener.on("click", function () {
        if ($body.hasClass("menu-open")) {
            $body.removeClass("menu-open");
            $menuOpener.text("/menu");
        } else {
            $body.addClass("menu-open");
            $menuOpener.text("/close");
        }
    });

    $(window).on("scroll load", function () {
        if ($window.scrollTop() > 0 && $window.innerWidth() >= 1180) {
            $header.addClass("sticky");
        } else {
            $header.removeClass("sticky");
        }
    });
    $(".header .main-nav a, .footer .footer-nav a").on("click", function (e) {
        let $this = $(this);
        let href = $this.attr("href");
        let target = href.replace(/^.*#/, "#");
        let documentHeight = $(document).innerHeight();
        if ($(".hero-section").length && $(target).length) {
            e.preventDefault();
            if ($body.hasClass("menu-open")) {
                $body.removeClass("menu-open");
                $menuOpener.text("/menu");
            }
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 600);
            setTimeout(function () {
                let newDocumentHeight = $(document).innerHeight();
                if (documentHeight != newDocumentHeight) {
                    $('html, body').animate({
                        scrollTop: $(target).offset().top
                    }, 200);
                }
            }, 600);
        }
    });
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $("body").addClass("mac-os");
    } else {
        $("body").addClass("win-os");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerNav.js